import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ModalService} from './services/modal/modal-service';
import {BrandingService} from './services/branding/branding-service';
import {HeaderGlobal} from './components/header-global/header-global';
import {MenuGlobal} from './components/menu-global/menu-global';
import {MainGlobal} from './components/main-global/main-global';
import {LoaderComponent} from './components/loader/loader.component';
import {routes} from './app.routes';
import {TableActionsComponent} from './widgets/table-actions/table-actions.component';
import {ToastComponent} from './widgets/toast/toast.component';
import {DtActionsService} from './widgets/data-table/services/dt-actions.service';
import {AuthService} from './services/auth/auth-service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderGlobal, MenuGlobal, MainGlobal, LoaderComponent, TableActionsComponent, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, AfterViewInit {
  @ViewChild('modalContainer', {read: ViewContainerRef})
  set modalContainerRef(vc: ViewContainerRef) {
    if (vc) {
      this.modalContainer = vc;
      this.modalService.setRootViewContainerRef(vc);
    }
  }

  private modalContainer!: ViewContainerRef;

  readonly pageWithoutHeader = ['', 'login', 'recovery-psw'];

  isBrandingReady = false;

  constructor(
    private modalService: ModalService,
    private brandingService: BrandingService,
    private actionService: DtActionsService,
    private authService: AuthService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // Inizializza il branding e mostra i contenuti solo quando pronto
    this.brandingService.initBranding();
    this.brandingService.ready$.subscribe(ready => {
      this.isBrandingReady = ready;
      this.ref.markForCheck();
    });
  }

  ngAfterViewInit() {

  }

  get showActions() {
    return this.actionService.actions().length > 0;
  }

  /**
   * Mostro l'header solo nelle pagine in cui serve
   */
  get showHeader() {
    if (!this.authService.isAuthenticated()) {
      return false;
    }

    const currentPath = window.location.pathname.split('/')[1];
    const currentUrl = window.location.href;

    const isRoot = currentUrl === 'http://localhost:4200' || currentUrl === 'http://localhost:4200/';

    const routeExists = routes.some(r => {
      if (!r.path) return false;
      const basePath = r.path.split('/')[0];
      return basePath === currentPath;
    });

    return (
      !this.pageWithoutHeader.includes(currentPath) &&
      !isRoot &&
      routeExists
    );
  }
}
